import { CurrencyModel } from 'models/Settings/Financial/CurrencyModel';
import { ReservationCardGroupModel } from 'pages/ReservationModule/pages/CreateReservationPageNew/models';
import { exportFileTypes } from '../../../../../models/exportFileTypes';

export enum CurrencyApplicationEnum {
  FIXED = 'fixed',
  DAILY = 'daily',
}

export interface FourWeekForecastReportFormModel {
  month: string | null;
  company: ReservationCardGroupModel | null;
  rates: Array<number>;
  // roomType: number | null;
  roomTypeIds: number[] | null;
  with_revenue: boolean;
  currency: CurrencyModel | null;
  currency_application: CurrencyApplicationEnum | null;
  fixed_at: string | null;
  sub_filter: SubFilterEnum;
  filter: FilterEnum;
  gross_revenue: boolean;
  group_by: GroupByEnum;
  file_type: exportFileTypes;
}

export enum GroupByEnum {
  MARKET = 'market',
  MARKET_SEGMENT = 'market_segment',
}

export enum FilterEnum {
  ROOM = 'room',
  PAX = 'pax',
}

export enum SubFilterEnum {
  NONE = 'none',
  ALLOCATION = 'allocation',
  GUARANTEE = 'guarantee',
}
